import { UploadFile } from 'antd/lib/upload/interface';
import { theme } from 'configs/styled';
import InputCheckBox, {
  InputCheckBoxProp,
} from 'containers/DriverPortalPage/components/InputCheckBox';
import TextRegular from 'containers/DriverPortalPage/components/TextRegular';
import Title from 'containers/DriverPortalPage/components/Title';
import React from 'react';
import RequiredTitle from '../components/RequiredTitle';
import BulletList from './BulletList';
import DocumentStatus from './DocumentStatus';
import PreviewButton from './PreviewButton';
import UploadImage, { IRequestUpload } from './UploadImage';

export interface IUploadImageForm {
  title: string;
  styleTitle?: React.CSSProperties;
  description?: string;
  bulletList: string[];
  pathImage?: string;
  required?: boolean;
  requiredTitle?: boolean;
  previewTitle?: string;
  previewUrl?: string;
  folder: string;
  onChange: (value: IRequestUpload) => void;
  onRemove?: (file: UploadFile) => void;
  nameImage?: string;
  disabled?: boolean;
  onChecked?: boolean;
  renderCheckbox?: InputCheckBoxProp;
  consent?: { title?: string; content?: string };
  statusDocs?: string;

  hasNewFile?: boolean;
  isPdf?: boolean;
  fileName?: string;
}

const UploadImageForm: React.FC<IUploadImageForm> = props => {
  const {
    title,
    styleTitle,
    required,
    requiredTitle,
    bulletList,
    previewTitle,
    previewUrl,
    description,
    onChange,
    onRemove,
    pathImage,
    nameImage,
    disabled,
    folder: folderType,
    onChecked,
    renderCheckbox,
    consent,
    hasNewFile = false,
    statusDocs,
    isPdf = false,
    fileName = '',
  } = props;

  const effectivePathImage = hasNewFile ? '' : pathImage;

  return (
    <div style={{ marginBottom: theme.spacing.xl }}>
      {required || requiredTitle ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'center',
          }}
        >
          <div>
            <RequiredTitle
              fontSize={theme.fontSize.md}
              message={title}
              style={styleTitle}
            />
          </div>
          {statusDocs && (
            <div>
              <DocumentStatus statusName={statusDocs ?? ''} />
            </div>
          )}
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'center',
          }}
        >
          <div>
            <Title style={styleTitle} fontSize={theme.fontSize.md}>
              {title}
            </Title>
          </div>
        </div>
      )}

      {description && (
        <TextRegular
          margin={`${theme.spacing.xs} 0px ${theme.spacing.xs}`}
          display={'block'}
          color={theme.palettes.black85}
        >
          {description}
        </TextRegular>
      )}

      <BulletList items={bulletList} />

      {renderCheckbox?.name ? <InputCheckBox {...renderCheckbox} /> : ''}

      {previewTitle && previewUrl ? (
        <PreviewButton title={previewTitle} url={previewUrl}>
          <BulletList items={bulletList} />
        </PreviewButton>
      ) : null}

      <UploadImage
        onRemove={onRemove}
        onChange={onChange}
        pathImage={effectivePathImage}
        nameImage={nameImage}
        disabled={disabled}
        folder={folderType}
        onChecked={onChecked}
        consent={consent}
        isPdf={isPdf}
        fileName={fileName}
      />
    </div>
  );
};

export default UploadImageForm;
